// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    createSales,
    deleteSales,
    deleteSalesDetails,
    getSalesApi,
    getSalesNoApi,
    updateSales,
} from '../../api/SalesApi'; // Adjust the path as needed
import {
    getSalesSuccess,
    getSalesFailure,
    createSalesSuccess,
    createSalesFailure,
    updateSalesSuccess,
    updateSalesFailure,
    deleteSalesSuccess,
    deleteSalesFailure,
    getSalesNoSuccess,
    getSalesNoFailure,
} from './actions';

// Saga to handle fetching Saless
function* fetchSalesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getSalesApi, action.payload);
        yield put(getSalesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getSalesFailure(errorMessage));
    }
}

// Saga to handle fetching Saless
function* fetchSalesNoSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getSalesNoApi, action.payload);
        yield put(getSalesNoSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getSalesNoFailure(errorMessage));
    }
}

// // Saga to handle creating a Sales
function* createSalesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createSales, action.payload);
        yield put(createSalesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createSalesFailure(errorMessage));
    }
}

// // Saga to handle updating a Sales
function* updateSalesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateSales, action.payload.data, action.payload.id);
        yield put(updateSalesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateSalesFailure(errorMessage));
    }
}

// // Saga to handle updating a Sales
function* deleteSalesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteSales, action.payload.id);
        yield put(deleteSalesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteSalesFailure(errorMessage));
    }
}

function* deleteSalesDetailsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteSalesDetails, action.payload.id);
        yield put(deleteSalesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteSalesFailure(errorMessage));
    }
}

export default function* SalesSaga() {
    yield takeEvery('GET_SALES_NO_REQUEST', fetchSalesNoSaga);
    yield takeEvery('GET_SALES_REQUEST', fetchSalesSaga);
    yield takeEvery('CREATE_SALES_REQUEST', createSalesSaga);
    yield takeEvery('UPDATE_SALES_REQUEST', updateSalesSaga);
    yield takeEvery('DELETE_SALES_REQUEST', deleteSalesSaga);
    yield takeEvery('DELETE_SALES_DETAIL_REQUEST', deleteSalesDetailsSaga);
}
